import { createContext } from 'react'

export const AIEmailAgentBannerDismissedContext = createContext({
  isBannerDismissed: false,
  isCafEmailAgentFeatureEnabled: false,
  setIsBannerDismissed: () => {}
})
